import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"
//STYLES
import styled from "styled-components"
import { down } from "styled-breakpoints"
import { theme } from "../utils/theme"
import { Label, H4, H2, Text } from "../utils/typo"
//COMPONENTS
import SEO from "../components/seo/SEO"
import Layout from "../layout/layout2"
import { ContainerMob, Container } from "../utils/utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faArrowLeft,
  faClock,
  faGraduationCap,
  faList,
  faLocationArrow,
  faMoneyBill,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons"

const Baner = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 100px 100px;
  background: rgb(5, 39, 102);
  background: linear-gradient(
    158deg,
    ${theme.color.prim1} 0%,
    ${theme.color.prim1} 20%,
    ${theme.color.base1} 88%,
    rgba(194, 241, 255, 1) 100%
  );

  ${down("sm")} {
    padding-top: 5rem;
  }

  div {
    p {
      font-weight: 700;
      color: white;
    }
  }
`

const Button = styled(Link)`
  background-color: transparent;
  border: 1px solid ${theme.color.base7};
  display: flex;
  align-self: flex-start;
  justify-content: center;
  padding: 0.7rem 2rem;
  color: ${theme.color.base9};
  border-radius: 10px;
  line-height: 1;
  font-weight: 600;
  transition: all 0.4s ease-in-out;
  margin-top: -1rem;

  svg {
    margin-right: 1rem;
  }
  :hover {
    color: ${theme.color.prim1};
    background-color: ${theme.color.base3};
  }
`

const CardWrapper = styled(Container)`
  display: grid;
  padding-left: 0;
  padding-right: 0;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  grid-template-columns: 2fr 1fr;

  ${down("sm")} {
    grid-template-columns: repeat(${props => props.s || 1}, 1fr);
  }

  ${down("xs")} {
    grid-template-columns: repeat(${props => props.xs || 1}, 1fr);
  }

  span {
    margin-bottom: 4rem;
  }
`

const Card = styled.div`
  margin-top: calc(-100px);
  background-color: white;
  padding: 2rem;
  outline: 1px solid lightgray;
  align-self: flex-start;

  ${down("sm")} {
    margin-top: 0;
    margin-bottom: 3rem;
  }
`

const IconWrapper = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  font-size: 20px;
  color: ${theme.color.grey4};
  margin-top: 1rem;
  align-items: center;
`

const OfertaWrapper = styled.div`
  padding: 3rem 0;
  h4,
  h2 {
    margin-bottom: 1rem;
  }

  h4 {
    margin-top: 4rem;
  }
  p {
    &:first-of-type {
      font-weight: 700;
    }
  }
`

const Oferty = ({ pageContext, data }) => {
  let { page } = data
  const kariera = data.datoCmsKarieraPage

  return (
    <div>
      <SEO
        title={kariera.seo.title || "Elcam"}
        description={kariera.seo.description || "oferty pracy"}
        slug={page.slug}
        image={kariera.seo.image.url}
      />
      <Layout lang={pageContext.locale} slug={pageContext.slug}>
        <Baner>
          <ContainerMob mt="0rem" mtMobile="2rem"></ContainerMob>
          <ContainerMob>
            <Button
              to={pageContext.locale === "pl-PL" ? "/kariera" : "/en/kariera"}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              Lista ofert pracy
            </Button>
          </ContainerMob>
        </Baner>

        <ContainerMob>
          <CardWrapper>
            <OfertaWrapper>
              <H2>{page.jobName}</H2>
              <Text dangerouslySetInnerHTML={{ __html: page.informacje }} />
              <H4>Wymagania</H4>
              <Text dangerouslySetInnerHTML={{ __html: page.wymagania }} />
              <H4>Mile widziane</H4>
              <Text dangerouslySetInnerHTML={{ __html: page.mileWidziane }} />
              <H4>Z Elcamem zyskujesz</H4>
              <Text dangerouslySetInnerHTML={{ __html: page.zyskujesz }} />
            </OfertaWrapper>
            <span>
              <Card>
                {/* <H4 colorFont={theme.color.base1}>{page.jobName}</H4> */}
                <IconWrapper>
                  <FontAwesomeIcon icon={faLocationArrow} />
                  <div>
                    <Label>Lokalizacja</Label>
                    <Text>
                      <b>{page.lokalizacja}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faClock} />
                  <div>
                    <Label>Wymiar etatu</Label>
                    <Text>
                      <b>{page.wymiarEtatu}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faMoneyBill} />
                  <div>
                    <Label>Wynagrodzenie</Label>
                    <Text>
                      <b>{page.wynagrodzenie}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faList} />
                  <div>
                    <Label>Rodzaj umowy</Label>
                    <Text>
                      <b>{page.rodzajUmowy}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faMoneyBill} />
                  <div>
                    <Label>Liczba wakatów</Label>
                    <Text>
                      <b>{page.liczbaWakatow}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faPlusCircle} />
                  <div>
                    <Label>Benefity</Label>
                    <Text>
                      <b>{page.benefity}</b>
                    </Text>
                  </div>
                </IconWrapper>

                <IconWrapper>
                  <FontAwesomeIcon icon={faGraduationCap} />
                  <div>
                    <Label>Szkolenia</Label>
                    <Text>
                      <b>{page.szkolenia}</b>
                    </Text>
                  </div>
                </IconWrapper>
              </Card>
              <Text mt="2rem">Aplikacje prosimy przesyłać na adres:</Text>
              <Text mt="1rem">
                <b>{kariera.kontaktMail}</b>
              </Text>
              <Text>{kariera.kontaktTelefon}</Text>
              <Text mt="2rem">
                <b>CV powinno zawierać klauzulę informacyjną:</b>
              </Text>
              <Text
                mt="1rem"
                dangerouslySetInnerHTML={{ __html: kariera.rodo }}
              />
            </span>
          </CardWrapper>
        </ContainerMob>
      </Layout>
    </div>
  )
}
export default Oferty

export const query = graphql`
  query OfertQuery($locale: String!, $slug: String!) {
    page: datoCmsOfertyPracy(locale: { eq: $locale }, slug: { eq: $slug }) {
      locale
      slug
      id
      jobName
      informacje
      wymagania
      mileWidziane
      zyskujesz
      lokalizacja
      wymiarEtatu
      rodzajUmowy
      liczbaWakatow
      benefity
      wynagrodzenie
      szkolenia
    }

    datoCmsKarieraPage(locale: { eq: $locale }) {
      rodo
      kontaktTelefon
      kontaktMail
      seo {
        description
        title
        image {
          url
        }
      }
    }
  }
`
